(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Load Swiper CSS
  if (!document.querySelector('#swiper-css')) {
    const swiperCSS = document.createElement('link');
    swiperCSS.id = 'swiper-css';
    swiperCSS.rel = 'stylesheet';
    swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(swiperCSS);
  }

  function initFAQSection() {
    const section = document.querySelector('.faq-accordion-slider');
    if (!section) return;

    const swiperEl = section.querySelector('.faq-accordion-swiper');
    if (!swiperEl) return;

    const slidesPerView = parseInt(swiperEl.dataset.slidesPerView) || 5;
    const spaceBetween = parseInt(swiperEl.dataset.spaceBetween) || 20;

    // Initialize Swiper
    try {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
        },
      });
    } catch (error) {
      console.error('Swiper initialization error:', error);
    }
  }

  // Load and initialize
  function loadSwiperAndInit() {
    if (typeof Swiper === 'undefined') {
      const swiperScript = document.createElement('script');
      swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      swiperScript.onload = function() {
        console.log('Swiper JS loaded');
        setTimeout(initFAQSection, 100);
      };
      swiperScript.onerror = function() {
        console.error('Failed to load Swiper JS');
      };
      document.head.appendChild(swiperScript);
    } else {
      initFAQSection();
    }
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadSwiperAndInit);
  } else {
    loadSwiperAndInit();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-slider"]) return;
  try {
    
// Initialize Horizon carousel
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.faq-carousel');
  carousels.forEach(c => {
    if (typeof HorizonCarousel !== 'undefined') {
      new HorizonCarousel(c, {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.items = Array.from(this.querySelectorAll('.faq__item'));

          this.items.forEach((item) => {
            const summary = item.querySelector('.faq__question');
            if (!summary) return;
            summary.addEventListener('click', (event) => {
              event.preventDefault();
              this.toggle(item);
            });
          });
        }

        get singleOpen() {
          return this.dataset.singleOpen === 'true';
        }

        toggle(item) {
          if (item.hasAttribute('open')) {
            this.close(item);
          } else {
            if (this.singleOpen) {
              this.items.forEach((other) => {
                if (other !== item) this.close(other);
              });
            }
            this.open(item);
          }
        }

        open(item) {
          const answer = item.querySelector('.faq__answer');
          item.setAttribute('open', '');
          if (!answer || this.reduceMotion) return;

          answer.style.height = '0px';
          requestAnimationFrame(() => {
            answer.style.height = answer.scrollHeight + 'px';
          });

          answer.addEventListener(
            'transitionend',
            () => {
              answer.style.height = 'auto';
            },
            { once: true }
          );
        }

        close(item) {
          if (!item.hasAttribute('open')) return;
          const answer = item.querySelector('.faq__answer');

          if (!answer || this.reduceMotion) {
            item.removeAttribute('open');
            return;
          }

          answer.style.height = answer.scrollHeight + 'px';
          requestAnimationFrame(() => {
            answer.style.height = '0px';
          });

          answer.addEventListener(
            'transitionend',
            () => {
              item.removeAttribute('open');
              answer.style.height = '';
            },
            { once: true }
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
